export default{
    path: 'notice',
    name: 'NoticeForm',
    component(){
        return import('@/components/notice/NoticeForm.vue');
    },
    children:[
        {
            path: '',
            name: 'NoticeList',
            component() {
                return import('@/components/notice/notice/NoticeList.vue');
            }
        },
        {
            path: ':seqnr',
            name: 'NoticeDetail',
            component() {
                return import('@/components/notice/notice/NoticeDetail.vue')
            }

        }

    ],
}